import { useState } from "react";
import useModal from "./SwalModals/useModal";

// The custom hook with validation handling optional chaining

// Custom function to access nested properties dynamically
function get(payload, path) {
  const pathArray = path.split("."); // Split the path into an array of keys
  let value = payload;

  // Traverse through each key in the path
  for (let key of pathArray) {
    if (value && value.hasOwnProperty(key)) {
      value = value[key]; // Access the next level
    } else {
      return undefined; // If a key doesn't exist, return undefined
    }
  }
  console.log("logFromGet", value);

  return value; // Return the final value found at the path
}

const useFormSubmitValidation = (validationRules, payload) => {
  const Modal = useModal();
  console.log("fromFormValidationnnn", validationRules, payload);

  const validate = () => {
    let formIsValid = true;

    // Iterate through validation rules and check conditions
    validationRules.forEach((rule) => {
      const { path, errorMessage, condition = (value) => !value } = rule;
      console.log("pathFromHook", path, errorMessage, condition);

      const value = get(payload, path);

      if (condition(value)) {
        Modal("Validation Error", errorMessage, "error");
        formIsValid = false;
        return; // You can't break out of forEach directly, so return early from the function
      }
    });
    console.log("forIsValidddd", formIsValid);

    return formIsValid; // Return the validity status
  };

  // Call validate() immediately whenever this hook is invoked
  const isValid = validate();

  return isValid; // Return the current validation status (true or false)
};

export default get;
